export default __webpack_public_path__ + "static/media/car-button-icon.2ea48287.svg";